<div class="donut"  [ngStyle]="{'background': timerBackground}"></div>
<div class="number" >
    <span class="time" *ngIf="hoursPass !== '00'">{{hoursPass}}:{{minutesPass}}:{{secondsPass}}</span>
    <span class="time" *ngIf="hoursPass == '00'">{{minutesPass}}:{{secondsPass}}</span>
</div>

